import * as yup from 'yup';
import i18n from '../../translation/config';

const getAccountBalanceValidationSchema = () =>
  yup.object().shape(
    {
      amount: yup
        .string()
        .required(i18n.t('amount-required'))
        .test('maxDigitsAfterDecimal', i18n.t('amount-must-be-number-with-2-decimals-or-less'), (number: any) =>
          /^-?\d+(\.\d{1,2})?$/.test(number),
        ),
      phone: yup
        .string()
        .required(i18n.t('phone-required'))
        .matches(/([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/, i18n.t('valid-phone-number-required')),
      isCash: yup.boolean().when('isPosnet', {
        is: false,
        then: yup.boolean().oneOf([true], i18n.t('select-cash-payment')),
        otherwise: yup.boolean().when(['isCash', 'isPosnet'], {
          is: true,
          then: yup.boolean().oneOf([false], i18n.t('cash-and-posnet-not-allowed')),
        }),
      }),
      isPosnet: yup.boolean().when('isCash', {
        is: false,
        then: yup.boolean().oneOf([true], i18n.t('select-posnet-payment')),
        otherwise: yup.boolean().when(['isPosnet', 'isCash'], {
          is: true,
          then: yup.boolean().oneOf([false], i18n.t('posnet-must-be-one-of-two')),
        }),
      }),
    },
    [['isCash', 'isPosnet']],
  );

export default getAccountBalanceValidationSchema;
